import React, { useState } from 'react';

const JurosCompostos: React.FC = () => {
    const [capital, setCapital] = useState('');
    const [taxa, setTaxa] = useState('');
    const [tempo, setTempo] = useState('');
    const [periodo, setPeriodo] = useState('meses');

    const calcularJurosCompostos = () => {
        if (!capital || !taxa || !tempo) return null;

        const C = parseFloat(capital);
        const i = parseFloat(taxa) / 100;
        const t = periodo === 'anos' ? parseFloat(tempo) * 12 : parseFloat(tempo);

        const montante = C * Math.pow(1 + i, t);
        const juros = montante - C;

        return {
            montante: montante.toFixed(2),
            juros: juros.toFixed(2),
            capital: C.toFixed(2)
        };
    };

    const resultado = calcularJurosCompostos();

    return (
        <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Calculadora de Juros Compostos</h3>

            <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-4">
                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Capital inicial (R$)
                                <input
                                    type="number"
                                    value={capital}
                                    onChange={(e) => setCapital(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="1000"
                                />
                            </label>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Taxa de juros mensal (%)
                                <input
                                    type="number"
                                    value={taxa}
                                    onChange={(e) => setTaxa(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="1"
                                    step="0.1"
                                />
                            </label>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Tempo
                                <div className="flex space-x-2 mt-1">
                                    <input
                                        type="number"
                                        value={tempo}
                                        onChange={(e) => setTempo(e.target.value)}
                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                                        placeholder="12"
                                        aria-label="Tempo"
                                    />
                                    <select
                                        value={periodo}
                                        onChange={(e) => setPeriodo(e.target.value)}
                                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500"
                                        aria-label="Unidade de tempo"
                                    >
                                        <option value="meses">Meses</option>
                                        <option value="anos">Anos</option>
                                    </select>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <div>
                    {resultado && (
                        <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-6">
                            <h4 className="text-lg font-semibold text-indigo-900 mb-4">Resultado:</h4>
                            <div className="space-y-3">
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Capital inicial:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.capital}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Juros ganhos:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.juros}</span>
                                </div>
                                <div className="flex justify-between text-lg">
                                    <span className="text-indigo-700">Montante final:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.montante}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default JurosCompostos;
